import { Box } from '@mui/material';

import { useInterfaceLanguage } from '@/shared/i18n';

import { ENTERPRISE_COPY } from '../lib/constants';
import { SCta, SEnterpriseCard } from '../styled';
import { PaywallFeatureList, PaywallMinutes } from './PaywallFeatures';

type PaywallEnterpriseCardProps = {
  isCompact: boolean;
  isPurchaseInProgress: boolean;
  onContactSales: () => void;
};

export const PaywallEnterpriseCard = ({
  isCompact,
  isPurchaseInProgress,
  onContactSales,
}: PaywallEnterpriseCardProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <SEnterpriseCard $isCompact={isCompact} data-testid="trial-paywall-experiment-plan-enterprise">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, paddingBottom: isCompact ? 14 : 16 }}>
        <Box
          sx={{
            fontSize: isCompact ? 20 : 22,
            fontWeight: 600,
            letterSpacing: '-0.01em',
            lineHeight: isCompact ? '26px' : '28px',
          }}
          component="span"
        >
          {t('pricing.plan.enterprise')}
        </Box>
        <Box component="span" sx={{ color: 'grey.600', fontSize: 13, lineHeight: '17px', textWrap: 'pretty' }}>
          {t(ENTERPRISE_COPY.descriptionKey)}
        </Box>
      </Box>
      {!isCompact && <Box />}
      <Box sx={{ alignItems: 'baseline', display: 'flex' }}>
        <Box
          sx={{
            fontSize: isCompact ? 32 : 36,
            fontWeight: 700,
            hyphens: 'auto',
            letterSpacing: '-0.02em',
            lineHeight: isCompact ? '38px' : '42px',
            minWidth: 0,
            overflowWrap: 'anywhere',
          }}
          component="span"
        >
          {t('pricing.price.custom')}
        </Box>
      </Box>
      <Box sx={{ paddingTop: isCompact ? 14 : 16 }}>
        <PaywallMinutes label={t('pricing.minutes.custom')} isEnterprise />
      </Box>
      <PaywallFeatureList featureKeys={ENTERPRISE_COPY.featureKeys} isCompact={isCompact} />
      <SCta
        $isCompact={isCompact}
        $variant="outlined"
        data-testid="trial-paywall-experiment-cta-enterprise"
        disabled={isPurchaseInProgress}
        onClick={onContactSales}
      >
        {t('pricing.actions.contactUs')}
      </SCta>
    </SEnterpriseCard>
  );
};
